import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const DesktopFull = ({
  height = 52,
  width = 73,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 73 52" {...props}>
    <rect width="69" height="48" x="2" y="2" fill={getColor(color, isColorInherited)} rx="5" />
    <rect
      width="68"
      height="47"
      x="2.5"
      y="2.5"
      stroke={getColor(color, isColorInherited)}
      rx="4.5"
    />
  </SvgIcon>
);
